<template>
  <div class="PaymentRecord" style="padding-top: 10px;">
    <!-- 查询当月未进行服务的老人列表 -->
    <el-row>
      <el-form
        :inline="true"
        :model="addForm"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
        @submit.native.prevent
      >
        <el-form-item label="月份">
          <el-date-picker
            v-model="addForm.yearMonth"
            :clearable="false"
            type="month"
            value-format="yyyy-MM"
            placeholder="请选择月份"
          />
        </el-form-item>
        <el-form-item label="老人姓名">
          <el-input
            v-model="addForm.oldmanName"
            placeholder="请输入老人姓名"
            clearable
            @keyup.enter.native.prevent="enterSearch"
          ></el-input>

        </el-form-item>

        <el-form-item label="所属乡镇">
          <el-input
            v-model="addForm.street"
            placeholder="请输入乡镇"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item label="所属村">
          <el-input
            v-model="addForm.community"
            placeholder="请输入村名"
            clearable
          ></el-input>
        </el-form-item>
        
        <el-form-item>
          <el-button
           type="primary"
            icon="el-icon-search"
            plain
            @click="queryTable"
            >查询</el-button
          >
        </el-form-item>

        <el-form-item>
          <el-button
           type="info"
           icon="el-icon-upload"
            plain
            @click="downLoad"
            >导出</el-button
          >
        </el-form-item>


        <el-button type="info" @click="toLead" icon="el-icon-upload" plain>导入</el-button>

      </el-form>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-table
        :data="tableData"
        :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :row-style="tableRowStyle"
        style="width: 100%"
      >
      <el-table-column
        type="index"
        label="序号"
        :index="indexMethod"
        width="60">
      </el-table-column>
        <el-table-column
          prop="oldmanName"
          label="老人姓名"
          align="center"
          min-width="90"
        ></el-table-column>
        <el-table-column prop="sex" label="性别" min-width="50">
          <template slot-scope="scope">
            {{ scope.row.sex==0?'男':'女' }}
          </template>
        </el-table-column>
        <el-table-column prop="oldmanCard" label="身份证号" min-width="170"></el-table-column>
        <el-table-column prop="oldType" label="老人类别" min-width="100"></el-table-column>
        <el-table-column prop="street" label="所属乡镇" min-width="120"></el-table-column>
        <el-table-column prop="community" label="所属村" min-width="120"></el-table-column>
        <el-table-column prop="address" label="家庭住址" min-width="190" show-overflow-tooltip></el-table-column>
        
        <el-table-column prop="street" label="未服务月份" min-width="100">
          <template slot-scope="scope">
            {{ scope.row.currentYear }} - {{ scope.row.currentMonth }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="说明" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column
          prop="affixUrl"
          label="附件"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            <div style="flex:1;display:flex;width: 60%;height:60px;">
                <el-image style=" width:58px;height:58px;margin:1px;" :key="imgurl" 
                v-for="imgurl in scope.row.affixUrl.split(',')" 
                v-if="imgurl.length>10" :src="imgurl"/>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="option" label="详情" min-width="100px" align="center">
          <template slot-scope="scope">
            <el-button
              style="margin-right: 5px"
              type="primary"
              size="mini"
              plain
              @click="handleDelete(scope.row)"
              >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-pagination
      class="fenye"
      background
      layout="total,prev, pager, next"
      :total="total"
      :current-page.sync="pageNum"
      @current-change="changePage"
      align="center"
    ></el-pagination>


    <el-dialog title="数据导入" width="30%" :visible.sync="toLeadVisisble" :close-on-click-modal="false"
        @close="toLeadCloseDialog">
        <el-row type="flex" justify="center">
          <el-col :span="20">
            <p>请在当月未服务老人中导出当月的名单后在excel中填写完毕后再导入</p>
            <el-row>
              <el-col :span="24">
                <input type="file" ref="file" id="file" @change="getUrl" />
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click.native="toLeadVisisble = false">取消</el-button>
          <el-button type="primary" @click.native="intoForm">确定</el-button>
        </div>
      </el-dialog>

     <!-- 消费记录 -->
     <el-dialog title="服务记录" width="70%" :visible.sync="dialogConsumption" :close-on-click-modal="false">
      
    </el-dialog>

  </div>
</template>
<script>
import util from "@/utils/util.js";
import { baseURL } from "@/utils/request.js";
export default {
  data() {
    return {
      tableData: [], //老人列表数据
      addForm: {
        oldmanName: "", //搜索查询老人
        community:"",
        street:"",
        currentYear: util.formatDate.format(new Date(), 'yyyy'),
        currentMonth:  util.formatDate.format(new Date(), 'MM'),
        oldType:'',
      },
      areaList:[],
      dialogChargeVisible:false,
      toLeadVisisble: false,
      dialogConsumption:false,
      dialogRecharge:false,
      consumptionRecordList:[],
      consumptionPage:1,
      rechargePage:1,
      consumptionTotal:0,
      quertForm:{},
      formLabelWidth:"100px",
      chargeForm:{},
      fileFlag:false,
      toLeadForm:{},
      chargeLoading:false,
      //分页
      groupId:0,
      total: 0,
      pageNum: 1,
      pageSize: 10, //分页总数
      checkBill: [],
    };
  },
  methods: {
    
    // 上传导入
    toLead() {
      this.toLeadVisisble = true;
    },
    toLeadCloseDialog() {
      this.$refs.file.value = "";
    },
    getUrl(event) {
      let file = event.target.files;
      console.log(file);
      this.fileFlag = true; //by guo 2020-8-4-15:18添加
      this.toLeadForm = new FormData();
      this.toLeadForm.append("file", file[0]);
    },
    // 确认上传
    intoForm() {
      if (this.fileFlag) {
        this.$postFormData("omc/notServiceOldReason/importReason", this.toLeadForm).then((res) => {
          this.toLeadVisisble = false;
          this.fileFlag = false;
          this.toLeadForm = {};
          if (res.code == 200) {
            this.$message({ message: res.message, type: "success" });
            this.queryTable();
          } else {
            this.$message({ message: res.message, type: "error" });
          }
        });
      } else {
        this.$message({ message: "请选择文件", type: "error" });
      }
    },
    
    indexMethod(index){
      return (Number(this.pageNum-1) * Number(this.pageSize))+ index +1;
    },
     /* 
      模糊查询老人
      */
      querySearchAsync(queryString, cb) {
      let param = {
        oldName: queryString
      };
      this.$postJson("omc/Oldman/quickShowAllOldMan", param).then((res) => {
        var list = [{}];
        if (res.result.list.length > 0) {
          for (let i of res.result.list) {
            i.value = i.oldName; //将想要展示的数据作为value
          }
          list = res.result.list;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: "",
          });
          cb(arr);
        }
      });
    },
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    handleDelete(row){
      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$postJson("omc/notServiceOldReason/deleteAbnormalApplication", {id:row.id}).then((res) => {
            if (res.code == 200) {
                this.queryPayList(); //刷新数据列表
                this.$message({ message: "删除成功", type: "success" });
            } else {
                this.$message({ message: res.message, type: "error" });
            }
          });
          
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        })
    },
    //查询欠费列表
    queryPayList() {
      let param = {
        oldmanName: this.addForm.oldmanName,
        yearMonth: this.addForm.yearMonth,
        community: this.addForm.community,
        oldType: "特困对象",
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.$postJson("omc/notServiceOldReason/getAbnormalApplicationPage", param).then((res) => {
        this.tableData = res.result.list; //列表数据
        this.total = Number(res.result.total); //页码total
      });
    },
    //回车enter回车查询
    enterSearch(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.queryPayList();
      }
    },
    //导出
    downLoad() {
      let params = {
        oldmanName: this.addForm.oldmanName,
        yearMonth: this.addForm.yearMonth,
        oldTypeName:this.addForm.oldTypeName,
        community: this.addForm.community,
        pageNum: 1,
        pageSize: 99999,
        groupId: this.groupId
      };
      const queryParams = Object.keys(params)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&');
      window.location.href =
          baseURL +
          `omc/api/downNotServiceOld?${queryParams}`;
    },

    //搜索查询搜索查询
    queryTable() {
      this.pageNum = 1;
      this.queryPayList();
    },
    //分页
    changePage(val) {
      this.pageNum = val;
      this.queryPayList();
    },
  },
  //自动刷新
  mounted() {
    this.groupId = sessionStorage.getItem("groupId");
    this.queryPayList(); //刷新欠费列表的数据
  },
};
</script>
<style lang="scss" scoped>
.PaymentRecord{
  padding-left: 10px;
  padding-right: 10px;
}
.curcor {
  font-size: 28px;
  color: rgb(1, 185, 237);
  cursor: pointer;
}
.are {
  color: #369a52;
}
.no {
  color: red;
}
.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}
</style>
